// extracted by mini-css-extract-plugin
export default {"root":"MerchantPurposeOption_root__BADtI","active":"MerchantPurposeOption_active__HSHDv","iconWrapper":"MerchantPurposeOption_iconWrapper__3M-bt"};